<template>
  <form class="form" method="post">

    <div id="appClientHistoryVueComponent" class="appFontBlack">
      <HeaderApp />
      <h2>Historique client</h2>
      <h2>{{ client.firstname }} {{ client.lastname }} </h2>
      <div :key="index" v-for="(item, index) in technicalArray" class="appClientCardList">
        <div class="appClientCardListLine1">
          <p>{{ item.date }}</p>
          <p @click.prevent="linkInvoice(item)" type="submit" class="appHoverEffect">{{ item.invoiceNumber }}</p>
        </div>
        <div class="appClientCardListLine4">
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'appClientsHistory',
  data () {
    return {
      technicalArray: '',
      client: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/clients/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.technicalArray = response.data.technicalsDatas.reverse()
        this.client = response.data
      })
  },
  methods: {
    linkInvoice (item) {
      if (item.invoiceId !== '-') {
        this.$router.push('/App/Collection/Paiement/Facture?id=' + item.invoiceId)
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppClientsHistory.vue